<ng-container *ngIf="selectedMortgage$ | async as selectedMortgage">
	<app-matter-llc
		[matterMortgage]="selectedMortgage"
		*ngIf="selectedMortgage?.type === MATTER_MORTGAGE_INSTRUCTION_SOURCE.LLC"
	></app-matter-llc>
	<app-manual-mortgage
		[matterMortgage]="selectedMortgage"
		*ngIf="selectedMortgage?.type === 'manual'"
	></app-manual-mortgage>
	<app-closer-sync-mortgage
		[matterMortgage]="selectedMortgage"
		*ngIf="
			selectedMortgage?.type === MATTER_MORTGAGE_INSTRUCTION_SOURCE.CLOSER_SYNC
		"
	></app-closer-sync-mortgage>
</ng-container>
